<template>
  <div class="footer">
    <b-card>
      <b-row>
        <b-col class="text-left" md="4">
          <b-button
            v-if="activeTab > 0"
            variant="link"
            class="text-transform-none"
            size="lg"
            @click="goBack()"
            :disabled="isLoading"
            :title="labels.back"
          >
            <i class="mdi mdi-arrow-left"></i>
            {{ labels.back }}
          </b-button>
        </b-col>
        <b-col class="text-center" md="4">
          <b-button
            v-if="activeTab > 0"
            variant="secondary"
            @click="$emit('saveDraftAndExit')"
            :disabled="isLoading"
            :title="labels.save"
          >
            <i class="mdi mdi-loading mdi-spin" v-if="isLoading"></i>
            <i class="mdi mdi-content-save" v-else></i>
            {{ labels.save }}
          </b-button>
        </b-col>
        <b-col class="text-right" md="4">
          <b-button
            v-if="activeTab < (isTemplate ? 1 : 2)"
            variant="link"
            class="text-transform-none"
            size="lg"
            @click="goForward()"
            :disabled="isLoading"
            :title="labels.next"
          >
            {{ labels.next }}
            <i class="mdi mdi-arrow-right"></i>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const props = {
  activeTab: {
    type: Number,
    default: 0,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
}

export default {
  props,
  computed: {
    ...mapGetters({
      resources: 'resources',
      isTemplate: 'customSurveys/isTemplate',
    }),
    labels() {
      return this.resources.component.customSurveys.create.layout.footer
    },
  },
  methods: {
    goBack() {
      this.$emit('changeTab', this.activeTab - 1)
    },
    goForward() {
      this.$emit('changeTab', this.activeTab + 1)
    },
  },
}
</script>

<style lang="scss" scoped>
.btn {
  border-radius: 10px !important;
  min-width: 160px;
}
</style>
